import colors from '../theme/colors';
import { radioClasses } from '@mui/material';
import palette from '../theme/palette';

const styleOverrides = {
  root: {
    padding: '4px',
    margin: '-4px',
    color: colors.transparentGray[400],
    [`&.${radioClasses.disabled}`]: {
      // preserve color, just change opacity
      color: colors.transparentGray[400],
      opacity: 0.4,
    },
  },
  // for primary, preserve color when disabled only if also checked
  colorPrimary: {
    [`&.${radioClasses.disabled}.${radioClasses.checked}`]: {
      color: palette.primary.main,
    },
  },
  // for internal, preserve internal color when disabled, even if not checked
  colorInternal: {
    [`&.${radioClasses.disabled}`]: {
      color: palette.internal.main,
    },
  },
  // other variants (colors) not documented on Figma, but may follow suit in the future.
};

export default styleOverrides;
